import { HttpStatusCode } from "axios";
import IEntry from "../models/blog/IEntry";
import networkService from "./NetworkService";
import IEntryPreivew from "../models/blog/IEntryPreview";

class BlogService {

    /**
     * @description Gets all blogs
     */
    async getBlogs(ignoreRegion: boolean = false, showFuture: boolean = false): Promise<IEntry[]> {
        let endpoint = `/blog/entries?ignoreRegion=${ignoreRegion}`;
        if (showFuture) {
            endpoint += `&showFuture=${showFuture}`;
        }

        const result = await networkService.get<IEntry[]>(endpoint);

        if (!result.isSuccessful) {
            throw result.data;
        }

        if (result.status === HttpStatusCode.NoContent) {
            return [];
        }

        const entries = (result.data as IEntry[])
            .sort((a, b) => new Date(b.published).getTime() - new Date(a.published).getTime());

        return entries;
    }

    /**
     * @description Gets all blog previews
     */
    async getBlogPreviews(showFuture: boolean = false): Promise<IEntryPreivew[]> {
        let endpoint = "/blog/entries/previews";
        if (showFuture) {
            endpoint += `&showFuture=${showFuture}`;
        }

        const result = await networkService.get<IEntryPreivew[]>(endpoint);

        if (!result.isSuccessful) {
            throw result.data;
        }

        if (result.status === HttpStatusCode.NoContent) {
            return [];
        }
        
        const entries = (result.data as IEntryPreivew[])
            .sort((a, b) => new Date(b.published).getTime() - new Date(a.published).getTime());

        return entries;
    }

    /**
     * @description Gets the specified blog
     * @param {string} arg The ID or slug of the blog to be returned
     */
    async getBlog(arg: string): Promise<IEntry> {
        const result = await networkService.get<IEntry>(`/blog/entry/${arg}`);

        if (result.isSuccessful) {
            return result.data as IEntry;
        }

        throw result.data;
    }

    /**
     * @description Creates a new blog
     * @param {IEntry} blog The blog data to be created
     */
    async createBlog(blog: IEntry): Promise<string> {
        const result = await networkService.put<IEntry, string>(`/blog/entry`, blog);

        if (result.isSuccessful) {
            return result.data as string;
        }

        throw result.data;
    }

    /**
     * @description Updates the specified blog
     * @param {IEntry} blog The blog data to be updated
     */
    async updateBlog(blog: IEntry): Promise<IEntry> {
        const result = await networkService.patch<IEntry, IEntry>(`/blog/entry`, blog);

        if (result.isSuccessful) {
            return result.data as IEntry;
        }

        throw result.data;
    }

    /**
     * @description Deletes the specified blog
     * @param {string} id The ID of the blog to be deleted
     */
    async deleteBlog(id: string): Promise<boolean> {
        const result = await networkService.delete<void>(`/blog/entry/${id}`);
        return result.isSuccessful;
    }

}

const blogService = new BlogService();
export default blogService;